<template>
  <div class="number-metric">
    <Typography :variant="valueVariant" as="span">{{ valueText }}</Typography>
    <Typography v-if="resolvedLabel" variant="body-1" as="span">{{ resolvedLabel }}</Typography>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "NumberMetric",
  components: { Typography },
  props: {
    value: { type: [String, Number], default: null },
    prefix: { type: String, default: "" },
    suffix: { type: String, default: "" },
    label: { type: String, default: "" },
    isEarnings: { type: Boolean, default: false },
    isDollarBudget: { type: Boolean, default: false },
    basis: {
      type: String,
      default: null,
      validator: (value) => value == null || value === "PAID" || value === "PROJECTED",
    },
    size: {
      type: String,
      default: "big",
      validator: (value) => ["big", "small"].includes(value),
    },
  },
  computed: {
    isBig() {
      return this.size === "big";
    },
    valueVariant() {
      return this.isBig ? "h-1" : "h-3";
    },
    resolvedPrefix() {
      if (this.prefix) return this.prefix;
      if (this.isEarnings && this.isDollarBudget) return "$";
      return "";
    },
    resolvedSuffix() {
      if (this.suffix) return this.suffix;
      if (this.isEarnings && !this.isDollarBudget) {
        const count = Number(String(this.resolvedValue).replace(/,/g, ""));
        return this.$tc("programs.earnings.points", Number.isNaN(count) ? 2 : count);
      }
      return "";
    },
    resolvedLabel() {
      if (this.label) return this.label;
      if (!this.isEarnings) return "";
      if (this.basis === "PAID") return this.$t("programs.earnings.earned");
      if (this.basis === "PROJECTED") return this.$t("programs.earnings.estimated");
      return "";
    },
    resolvedValue() {
      const empty = this.value === null || this.value === undefined || this.value === "";
      if (this.isEarnings && this.isDollarBudget) {
        const amt = empty ? 0 : Number(this.value);
        if (!Number.isNaN(amt)) return amt.toFixed(2);
      }
      if (empty) return 0;
      return this.value;
    },
    // Prefix and suffix are part of the value's own text so they share its type
    // treatment: the prefix reads as one token ("$1,405.00"), the suffix as a
    // separate word ("200 points").
    valueText() {
      const parts = [this.resolvedValue, this.resolvedSuffix].filter(
        (part) => part != null && part !== ""
      );
      return `${this.resolvedPrefix}${parts.join(" ")}`;
    },
  },
};
</script>

<style scoped>
.number-metric {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
